import React from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { Upload, Button } from 'antd';
import { downloadFile } from "../../../utils";
import { apis } from "../../../constants";
import { DownloadOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

const UploadFile: React.FC<{ onFileChange: (file: any) => void, onDownloadTemplate?: () => void }> = ({ onDownloadTemplate, onFileChange }) => {
    return (
        <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', padding: 20 }}>
                <Button icon={<DownloadOutlined />} onClick={() => onDownloadTemplate ? onDownloadTemplate() : downloadFile(apis.downloadDeviceListTempalte)}>下载模板</Button>
            </div>
            <div style={{ padding: 20 }}>
                <div style={{ margin: '50px auto' }}>
                    <Dragger accept='.xlsx' beforeUpload={() => false}
                        onChange={e => {
                            onFileChange(e.file)
                        }}>
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">点击或拖拽文件到此处上传文件</p>
                    </Dragger>
                </div>
            </div>
        </div>
    );
}

export default UploadFile;